import React, { useEffect, useRef, useState } from "react";
import Attachments from "../../../components/Attachments/Attachments";
import Notifications from "../../../components/Notifications/Notifications";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useStateValue } from "../../../StateProvider";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import {
  AcceptTask,
  CancelTask,
  DoneTask,
  RejectTask,
  StartTask,
  addNewTask,
  checkSubtaskStatus,
  getAddNewTaskDetail,
  getAllTaskTempList,
  getTaskDetail,
  getTaskTemplateDetail,
  updateTaskDetail,
} from "../../../apiCall";
import "./AddUpdateTask.scss";
import Select from "react-select";

import toast from "react-hot-toast";
import { NewPasswordModal } from "../../../components/Modals/NewPasswordModal";
import { useNavigate, useParams } from "react-router-dom";
import SubTaskList from "../Components/SubTaskList";
import EncodeAprxDuration from "../../../utils/EncodeAprxDuration";
import { useQuery } from "@tanstack/react-query";
import DecodeAprxDuration from "../../../utils/DecodeAprxDuration";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal";
import { isAdmin } from "../../../utils/adminAccess";
import Attachment from "../../Attachment/Attachment";
import Notification from "../../Notification/Notification/Notification";
import calculateEndDate from "../../../utils/calculateEndDate";
import {
  convertToDateTimeLocalFormat,
  formatDateTimetoAmPm,
} from "../../../utils/FormateDate";
import {
  convertToUserOptions,
  customStyles,
} from "../../../utils/ConvertToOptions";
import { ConfirmationReasonModal } from "../../../components/Modals/ConfirmationResonModal";
import { validateNoBlankSpaces } from "../../../utils/formValidation";

const convertToOptions = (list) => {
  if (list?.length > 0) {
    return list.map((item) => ({
      value: item?.ID,
      label: `${item?.Name} ${
        item?.ProjTmplID
          ? `(Project Name:- ${item.parent_project_template_name})`
          : "(Standalone)"
      }`,
    }));
  }
  return [];
};

const formatDateTime = (datetimeString) => {
  const date = new Date(datetimeString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
const isDate1GreterThenDate2 = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  if (d1 > d2) {
    return true;
  } else {
    return false;
  }
};

const AddUpdateTask = () => {
  const [tab, setTab] = useState("information");
  const [{ userInfo }, dispatch] = useStateValue();
  const [profileImage, setSetProfileImage] = useState("");
  const [profileError, setProfileError] = useState(false);
  const [taskStatus, setTaskStatus] = useState("Pending");
  const [isSaveAndAddSubtask, setIsSaveAndAddSubtask] = useState(false);
  const [isSaveAndEditeSubtask, setIsSaveAndEditeSubtask] = useState(false);
  const [editSubTaskId, setEditSubTaskId] = useState();
  const [isDoneAction, setIsDoneAction] = useState(false);
  const [isCancelTaskAction, setIsCancelTaskAction] = useState(false);
  const [isStartAction, setIsStartAction] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [closingComment, setClosingComment] = useState("");
  const [delayReason, setDelayReason] = useState("");
  const [commentCount, setCommentCount] = useState(0);
  const [tranMID, setTranMID] = useState();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userFilter = searchParams.get("user_filter"); // Replace 'param1' with your parameter name
  const statusFilter = searchParams.get("status_filter");
  const searchFilter = encodeURIComponent(searchParams.get("search_filter"));
  const projectUserFilter = searchParams.get("project_user_filter"); // Replace 'param1' with your parameter name
  const projectStatusFilter = searchParams.get("project_status_filter");
  const projectSearchFilter = searchParams.get("project_search_filter");
  const taskType = searchParams.get("task_type");
  const userCode = searchParams.get("user_code");
  const [title, setTitle] = useState("Add Task");

  // # attachmentCount **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);

  const [isAddAttachments, setIsAddAttachments] = useState(false);
  const [isAddNotification, setIsAddNotification] = useState(false);

  // # attachmentCount **************************************************

  const navigate = useNavigate();
  const updateUrl = (newPath) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    // Construct new URL
    // const newPath = '/update/task/31';
    const newUrl = `${newPath}?${searchParams.toString()}`;

    // Navigate to the new URL
    navigate(newUrl);
  };

  const navigateToProjectWithId = (Id) => {
    if (projectStatusFilter && projectUserFilter) {
      navigate(
        `/update/project/${projectId}?taskId=${Id}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}`
      );
    } else if (projectStatusFilter) {
      navigate(
        `/update/project/${projectId}?taskId=${Id}&project_status_filter=${projectStatusFilter}&project_user_filter=All&project_search_filter=${projectSearchFilter}`
      );
    } else if (projectUserFilter) {
      navigate(
        `/update/project/${projectId}?taskId=${Id}&project_status_filter=All&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}`
      );
    } else {
      navigate(
        `/update/project/${projectId}?taskId=${Id}&project_status_filter=All&project_user_filter=All&project_search_filter=${projectSearchFilter}`
      );
    }
  };
  const navigateToProject = () => {
    if (projectStatusFilter && projectUserFilter) {
      navigate(
        `/update/project/${projectId}?project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}`
      );
    } else if (projectStatusFilter) {
      navigate(
        `/update/project/${projectId}?project_status_filter=${projectStatusFilter}&project_user_filter=All&project_search_filter=${projectSearchFilter}`
      );
    } else if (projectUserFilter) {
      navigate(
        `/update/project/${projectId}?project_status_filter=All&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}`
      );
    } else {
      navigate(
        `/update/project/${projectId}?project_status_filter=All&project_user_filter=All&project_search_filter=${projectSearchFilter}`
      );
    }
  };
  const navigateToTaskWithId = (Id) => {
    if (projectId) {
      navigateToProjectWithId(Id);
    } else {
      if (statusFilter && userFilter) {
        navigate(
          `/task?taskId=${Id}&status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else if (statusFilter) {
        navigate(
          `/task?taskId=${Id}&status_filter=${statusFilter}&user_filter=All&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else if (userFilter) {
        navigate(
          `/task?taskId=${Id}&status_filter=All&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else {
        navigate(
          `/task?taskId=${Id}&status_filter=All&user_filter=All&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      }
    }
  };
  const navigateToTask = (Id) => {
    if (projectId) {
      navigateToProject();
    } else {
      if (statusFilter && userFilter) {
        navigate(
          `/task?status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else if (statusFilter) {
        navigate(
          `/task?status_filter=${statusFilter}&user_filter=All&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else if (userFilter) {
        navigate(
          `/task?status_filter=All&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else {
        navigate(
          `/task?status_filter=All&user_filter=All&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      }
    }
  };
  const navigateToSubTaskWithId = (Id) => {
    if (statusFilter && userFilter) {
      navigate(
        `/update/subtask/${Id}?task_status=${taskStatus}&project_name=${
          watchedFields?.parentProjectName
        }&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else if (statusFilter) {
      navigate(
        `/update/subtask/${Id}?task_status=${taskStatus}&project_name=${
          watchedFields?.parentProjectName
        }&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=${statusFilter}&user_filter=All&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else if (userFilter) {
      navigate(
        `/update/subtask/${Id}?task_status=${taskStatus}&project_name=${
          watchedFields?.parentProjectName
        }&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=All&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    } else {
      navigate(
        `/update/subtask/${Id}?task_status=${taskStatus}&project_name=${
          watchedFields?.parentProjectName
        }&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=All&user_filter=All&search_filter=${searchFilter}&task_type=${
          taskType ? taskType : ""
        }&user_code=${userCode ? userCode : ""}`
      );
    }
  };
  const navigateToAddSubTaskWithId = (Id) => {
    if (projectId) {
      if (statusFilter && userFilter) {
        navigate(
          `/add/project/subtask/${
            projectId ? `${projectId}/${Id}` : Id
          }?project_name=${
            watchedFields?.parentProjectName
          }&task_status=${taskStatus}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else if (statusFilter) {
        navigate(
          `/add/project/subtask/${
            projectId ? `${projectId}/${Id}` : Id
          }?project_name=${
            watchedFields?.parentProjectName
          }&task_status=${taskStatus}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=${statusFilter}&user_filter=All&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else if (userFilter) {
        navigate(
          `/add/project/subtask/${
            projectId ? `${projectId}/${Id}` : Id
          }?project_name=${
            watchedFields?.parentProjectName
          }&task_status=${taskStatus}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=All&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else {
        navigate(
          `/add/project/subtask/${
            projectId ? `${projectId}/${Id}` : Id
          }?project_name=${
            watchedFields?.parentProjectName
          }&task_status=${taskStatus}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=All&user_filter=All&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      }
    } else {
      if (statusFilter && userFilter) {
        navigate(
          `/add/subtask/${projectId ? `${projectId}/${Id}` : Id}?project_name=${
            watchedFields?.parentProjectName
          }&task_status=${taskStatus}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=${statusFilter}&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else if (statusFilter) {
        navigate(
          `/add/subtask/${projectId ? `${projectId}/${Id}` : Id}?project_name=${
            watchedFields?.parentProjectName
          }&task_status=${taskStatus}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=${statusFilter}&user_filter=All&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else if (userFilter) {
        navigate(
          `/add/subtask/${projectId ? `${projectId}/${Id}` : Id}?project_name=${
            watchedFields?.parentProjectName
          }&task_status=${taskStatus}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=All&user_filter=${userFilter}&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      } else {
        navigate(
          `/add/subtask/${projectId ? `${projectId}/${Id}` : Id}?project_name=${
            watchedFields?.parentProjectName
          }&task_status=${taskStatus}&project_status_filter=${projectStatusFilter}&project_user_filter=${projectUserFilter}&project_search_filter=${projectSearchFilter}&project_id=${projectId}&status_filter=All&user_filter=All&search_filter=${searchFilter}&task_type=${
            taskType ? taskType : ""
          }&user_code=${userCode ? userCode : ""}`
        );
      }
    }
  };

  const { taskId } = useParams();
  const { projectId } = useParams();
  useEffect(() => {
    if (projectId) {
      setValue("ProjTranID", projectId);
    }
  }, [projectId]);
  const startTask = async (id) => {
    const re = await StartTask(id);
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToTaskWithId(id);
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };
  const doneTask = async (id, reason) => {
    const re = await DoneTask(id, { DelayReason: reason });
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToTaskWithId(id);

      // navigate(`/task?taskId=${id}`);

      // taskDetailRefetch();
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };
  const acceptTask = async (id, reason) => {
    const re = await AcceptTask(id, { ClosingComment: reason });
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToTaskWithId(id);

      // navigate(`/task?taskId=${id}`);

      // taskDetailRefetch();
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };
  const rejectTask = async (id, reason) => {
    const re = await RejectTask(id, { RejectReason: reason });
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToTaskWithId(id);

      // navigate(`/task?taskId=${id}`);

      // taskDetailRefetch();
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };
  const cancelTask = async (id, reson) => {
    const re = await CancelTask(id, { CancReason: reson });
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToTaskWithId(id);

      // navigate(`/task?taskId=${id}`);
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };

  const transformedArray = (inputArray) => {
    if (inputArray) {
      const output = inputArray.map((obj) => {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        return { id: key, value: value };
      });
      return output;
    }
    return [];
  };

  // // ********************************************** calculate end date ****************************************************
  const onDateOrDurationChange = (value, type) => {
    console.log(value, type);

    if (type === "startDate") {
      if (
        (watchedFields.AprxDays ||
          watchedFields.AprxHours ||
          watchedFields.AprxMinutes) &&
        value
      ) {
        const endDate = calculateEndDate(
          value,
          watchedFields.AprxDays,
          watchedFields.AprxHours,
          watchedFields.AprxMinutes
        );

        setValue("EndDtTm", endDate);
      }
    } else if (type === "day") {
      if (
        (value || watchedFields.AprxHours || watchedFields.AprxMinutes) &&
        watchedFields.StartDtTm
      ) {
        const endDate = calculateEndDate(
          watchedFields.StartDtTm,
          value,
          watchedFields.AprxHours,
          watchedFields.AprxMinutes
        );

        setValue("EndDtTm", endDate);
      }
    } else if (type === "hours") {
      if (
        (watchedFields.AprxDays || value || watchedFields.AprxMinutes) &&
        watchedFields.StartDtTm
      ) {
        const endDate = calculateEndDate(
          watchedFields.StartDtTm,
          watchedFields.AprxDays,
          value,
          watchedFields.AprxMinutes
        );

        setValue("EndDtTm", endDate);
      }
    } else if (type === "minutes") {
      if (
        (watchedFields.AprxDays || watchedFields.AprxHours || value) &&
        watchedFields.StartDtTm
      ) {
        const endDate = calculateEndDate(
          watchedFields.StartDtTm,
          watchedFields.AprxDays,
          watchedFields.AprxHours,
          value
        );

        setValue("EndDtTm", endDate);
      }
    }
  };
  // **********************************************  calculate end date ****************************************************

  // ********************************************** form start ****************************************************
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      AprxDays: 0,
      AprxHours: 0,
      AprxMinutes: 0,
      ActualDays: 0,
      ActualHours: 0,
      ActualMinutes: 0,
      // AllocBy: "SysAdm",
      // Country: "India",
    },
  });
  const watchedFields = watch();
  const onSubmit = async (data) => {
    if (
      (parseInt(data?.AprxDays) === 0 || data?.AprxDays === "") &&
      (parseInt(data?.AprxMinutes) === 0 || data?.AprxMinutes === "") &&
      (parseInt(data?.AprxHours) === 0 || data?.AprxHours === "")
    ) {
      toast.error("Days, hours and minutes cannot be 0.");
    } else {
      // **************************** formate dates start ****************************
      if (data.EndDtTm > data.StartDtTm) {
        data.StartDtTm = formatDateTime(data.StartDtTm);
        data.EndDtTm = formatDateTime(data.EndDtTm);
        delete data.ActualStDtTm;
        delete data.ActualEndDtTm;
        if (data?.planned_duration) {
          delete data.planned_duration;
        }

        // **************************** formate dates end ****************************
        // **************************** convert duration start ****************************
        const totalAprxDays = EncodeAprxDuration(
          data?.AprxDays === "" ? 0 : data?.AprxDays,
          data?.AprxHours === "" ? 0 : data?.AprxHours,
          data?.AprxMinutes === "" ? 0 : data?.AprxMinutes
        );
        data.Duration = totalAprxDays;
        delete data.AprxDays;
        delete data.AprxHours;
        delete data.AprxMinutes;

        delete data.ActualDays;
        delete data.ActualHours;
        delete data.ActualMinutes;
        // **************************** convert duration end ****************************

        dispatch({ type: "SET_LOADING", status: true });
        try {
          let re;
          if (taskId) {
            re = await updateTaskDetail(taskId, data);

            if (re?.status === 200) {
              if (isSaveAndEditeSubtask) {
                setIsSaveAndEditeSubtask(false);
                navigateToSubTaskWithId(editSubTaskId);
                // navigate(`/update/subtask/${editSubTaskId}`);
                reset();
                toast.success(re?.data?.message);
              } else {
                if (isSaveAndAddSubtask) {
                  setIsSaveAndAddSubtask(false);
                  navigateToAddSubTaskWithId(taskId);
                  // navigate(`/add/subtask/${taskId}`);
                  reset();
                  toast.success(re?.data?.message);
                } else if (isStartAction) {
                  handleConfirmationShow();
                  setFunHandler({
                    fun: startTask,
                    id: taskId,
                    title: "start task.",
                  });
                  setIsStartAction(false);
                } else if (isDoneAction) {
                  const re = await checkSubtaskStatus(taskId);
                  console.log(re);
                  if (re?.status === 200) {
                    handleConfirmationResonShow();
                    const specificDateTime = new Date(watchedFields.EndDtTm);

                    // Step 2: Get the current date and time
                    const currentDateTime = new Date();
                    setFunHandler({
                      fun: doneTask,
                      id: taskId,
                      isGetReason: currentDateTime > specificDateTime,
                      lable: "Delay task reason",

                      title: "change task status to done",
                    });
                    setIsDoneAction(false);
                  } else if (re?.response) {
                    toast.error(re.response.data.message);
                  }
                } else if (isCancelTaskAction) {
                  handleConfirmationResonShow();
                  setFunHandler({
                    fun: cancelTask,
                    id: taskId,
                    isGetReason: true,
                    lable: "Cancel task reason",
                    title: "cancel task",
                  });
                  setIsCancelTaskAction(false);
                } else if (isAddAttachments) {
                  setTab("attachments");
                  setTitle(taskId ? "Update Task" : "Add Task");
                  setIsAddAttachments(false);
                } else if (isAddNotification) {
                  setTab("notifications");
                  setTitle(taskId ? "Update Task" : "Add Task");

                  setIsAddNotification(false);
                } else {
                  navigateToTaskWithId(taskId);

                  // navigate(`/task?taskId=${taskId}`);
                  reset();
                  toast.success(re?.data?.message);
                }
              }
            } else if (re?.response) {
              toast.error(re?.response?.data?.message);
            }
          } else {
            re = await addNewTask(data, selectedTaskTempId);
            console.log(re);
            if (re?.status === 201) {
              reset();

              if (isSaveAndAddSubtask) {
                if (selectedTaskTempId) {
                  navigateToTaskWithId(re?.data?.data?.ID);

                  // navigate(`/task?taskId=${re?.data?.data?.ID}`);
                } else {
                  navigateToAddSubTaskWithId(re?.data?.data?.ID);
                  // navigate(`/add/subtask/${re?.data?.data?.ID}`);
                }
              } else if (isAddAttachments) {
                updateUrl(`/update/task/${re?.data?.data?.ID}`);

                setTab("attachments");
                // setTitle("Attachment List");
                setTitle(taskId ? "Update Task" : "Add Task");

                setIsAddAttachments(false);
              } else {
                navigateToTaskWithId(re?.data?.data?.ID);

                // navigate(`/task?taskId=${re?.data?.data?.ID}`);
              }

              toast.success(re?.data?.message);
            } else if (re?.response?.status) {
              toast.error(re?.response?.data?.message);
            }
          }
        } catch {}
        dispatch({ type: "SET_LOADING", status: false });
        // } else {
        //   setProfileError(true);
      } else {
        toast.error("End Date must be more than Start Date.");
      }
    }
  };
  // ********************************************** form end ****************************************************

  // ********************************************** remove image end ****************************************************
  const [show, setShow] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const handleClose = () => {
    setShow(false);
    setNewPassword("");
  };
  const handleShow = () => setShow(true);
  // ********************************************** get data start ****************************************************
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["new-task-form-data"],
    // enabled,
    queryFn: async () => {
      // Perform the API call to fetch company info
      try {
        dispatch({ type: "SET_LOADING", status: true });

        const response = await getAddNewTaskDetail(projectId);
        if (response?.status === 200) {
          setFormDefaultData(response.data.data);
          if (projectId && !taskId) {
            setValue(
              "OrdNo",
              parseInt(response.data?.data?.parent_project_info?.ord_no)
            );

            setValue(
              "parentProjectName",
              response.data?.data?.parent_project_info?.name
            );
            setValue(
              "parentProjectDescription",
              response.data?.data?.parent_project_info?.description
            );
            setValue(
              "parentProjectLead",
              response.data?.data?.parent_project_info?.lead
            );
          }
          if (!taskId) {
            setValue("Priority", "1");
          }
        } else if (response?.response) {
          toast.error(response.response.data.status);
        }

        dispatch({ type: "SET_LOADING", status: false });
        return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
      }
    },
  });
  const [formDefaultData, setFormDefaultData] = useState(
    data?.status === 200 ? data.data.data : {}
  );
  const [priorityOption, setPriorityOption] = useState(
    data?.status === 200 ? data.data.data?.priority_list : []
  );
  const [leadOption, setLeadOption] = useState(
    data?.status === 200 ? data.data.data : []
  );
  // ********************************************** get data end ****************************************************
  // ********************************************** get task data start****************************************************
  const fetchTask = async () => {
    // Perform the API call to fetch company info
    try {
      dispatch({ type: "SET_LOADING", status: true });

      const response = await getTaskDetail(taskId);

      if (response?.status === 200) {
        // setTaskTempList(response.data.data);
        setAttachmentCount(response.data?.attachments_no);
        setNotificationCount(response.data?.notifications?.unread);
        // setCommentCount(0)
        if (commentCount === 0) {
          let count = 0;
          if (response.data?.CancReason) {
            setCancelReason(response.data?.CancReason);
            count += 1;
            setCommentCount(count);
          }
          if (response.data?.RejectionReason) {
            setRejectionReason(response.data?.RejectionReason);
            count += 1;
            setCommentCount(count);
          }
          if (response.data?.DelayReason) {
            setDelayReason(response.data?.DelayReason);
            count += 1;
            setCommentCount(count);
          }
          if (response.data?.ClosingComment) {
            setClosingComment(response.data?.ClosingComment);
            count += 1;
            setCommentCount(count);
          }
        }
        setValue("ID", response.data?.ID);
        setValue("OrdNo", response.data?.OrdNo);
        setValue("Name", response.data?.Name);
        setValue("Dscr", response.data?.Dscr);
        setValue("TaskLead", response.data?.TaskLead);
        setValue("Status", response.data?.Status?.idx);
        setTaskStatus(response.data?.Status?.text);
        setValue("Priority", response.data?.Priority);
        setValue("AllocBy", response.data?.AllocBy);
        const [days, hours, minutes] = DecodeAprxDuration(
          response?.data?.Duration
        );
        setValue("planned_duration", response?.data?.planned_duration);
        setValue("AprxDays", days);
        setValue("AprxHours", hours);
        setValue("AprxMinutes", minutes);
        const [ActualDays, ActualHours, ActualMinutes] = DecodeAprxDuration(
          response?.data?.actual_duration
        );
        setValue("ActualDays", ActualDays);
        setValue("ActualHours", ActualHours);
        setValue("ActualMinutes", ActualMinutes);
        setValue("parentProjectName", response?.data?.parent_project_name);
        setValue(
          "parentProjectDescription",
          response?.data?.parent_project_description
        );
        setValue("parentProjectLead", response?.data?.parent_project_lead);
        setValue(
          "StartDtTm",
          convertToDateTimeLocalFormat(response?.data?.StartDtTm)
        );
        setValue(
          "EndDtTm",
          convertToDateTimeLocalFormat(response?.data?.EndDtTm)
        );
        if (response?.data?.ActualStDtTm) {
          setValue("ActualStDtTm", response?.data?.ActualStDtTm);
        }
        if (response?.data?.ActualEndDtTm) {
          setValue("ActualEndDtTm", response?.data?.ActualEndDtTm);
        }
      } else if (response?.response) {
        toast.error(response.response.data.message);
      }

      dispatch({ type: "SET_LOADING", status: false });
      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
    }
  };
  const { data: taskTempDetail, refetch: taskDetailRefetch } = useQuery({
    queryKey: ["task-detail"],
    queryFn: fetchTask,
    enabled: taskId ? true : false,
    // staleTime: Infinity,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  // ********************************************** get task data end ****************************************************

  useEffect(() => {
    if (!taskId) {
      setValue("Priority", "1");
      setValue("AllocBy", userInfo?.user_code);
      setValue("TaskLead", userInfo?.user_code);
    }
  }, [setValue, userInfo, taskId]);

  useEffect(() => {
    if (taskId && tab === "information") {
      setTitle("Update Task");
    }
    if (!taskId && tab === "information") {
      setTitle("Add Task");
    }
    setTranMID(taskId);
  }, [taskId]);

  const [funHandler, setFunHandler] = useState();
  const [confirmationShow, setConfirmationShow] = useState(false);
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);
  const [confirmationResonShow, setConfirmationResonShow] = useState(false);
  const handleConfirmationResonClose = () => {
    setConfirmationResonShow(false);
  };
  const handleConfirmationResonShow = () => setConfirmationResonShow(true);

  // *********************************************** task temp list fetch ************************************************
  const fetchTaskTemp = async () => {
    // Perform the API call to fetch company info
    try {
      const response = await getAllTaskTempList();
      if (response?.status === 200) {
        setTaskTempList(response.data.data);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const {
    isLoading: taskTempLoading,
    isFetching,
    data: taskTempListData,
    refetch: taskTempRefetch,
  } = useQuery({
    queryKey: ["task-temp-list"],
    enabled: !taskId ? true : false,

    queryFn: () => fetchTaskTemp(),

    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });

  const [taskTempList, setTaskTempList] = useState(
    taskTempListData?.status === 200 ? taskTempListData?.data?.data : []
  );
  const [selectedTaskTempId, setSelectedTaskTempId] = useState();
  const [selectedTaskTempOption, setSelectedTaskTempOption] = useState();
  const fetchTaskTempDetail = async (option) => {
    const temId = option.value;
    setSelectedTaskTempOption(option);
    setSelectedTaskTempId(temId);
    // Perform the API call to fetch company info
    try {
      dispatch({ type: "SET_LOADING", status: true });

      const response = await getTaskTemplateDetail(temId);
      if (response?.status === 200) {
        if (response.data?.ProjTmplID) {
          // setValue("OrdNo", response.data?.OrdNo);
        }
        setValue("Name", response.data?.Name);

        setValue("Dscr", response.data?.Dscr);
        const [days, hours, minutes] = DecodeAprxDuration(
          response?.data?.AprxDuration
        );
        setValue("AprxDays", days);
        setValue("AprxHours", hours);
        setValue("AprxMinutes", minutes);
      } else if (response?.response) {
        toast.error(response.response.data.message);
      }
      dispatch({ type: "SET_LOADING", status: false });

      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
      return error;
    }
  };
  const [getTaskFromTemp, setGetTaskFromTemp] = useState(false);
  const formRef = useRef(null);

  const handleExternalSubmit = (submitType) => {
    if (taskStatus === "Done" || taskStatus === "Cancelled") {
      setTab(submitType);
      setTitle(taskId ? "Update Task" : "Add Task");
    } else {
      if (tab === "information") {
        if (submitType === "attachments") {
          setIsAddAttachments(true);
        } else {
          setIsAddNotification(true);
        }
        if (formRef.current) {
          setTimeout(() => {
            formRef.current.dispatchEvent(
              new Event("submit", { cancelable: true, bubbles: true })
            );
          }, 100);
        }
      } else if (submitType === "attachments") {
        setTab("attachments");
        setTitle(taskId ? "Update Task" : "Add Task");
      } else {
        setTab("notifications");
        setTitle(taskId ? "Update Task" : "Add Task");
      }
    }
  };
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className=" mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between  px-6"
                >
                  {/* <div className="mb-6 mb-lg-0"> */}
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="">
                      <h1 className="mb-0 h3 ">{title}</h1>
                    </div>
                    <div lassName="status ">
                      <div
                        className="mb-0"
                        style={{ fontSize: "20px", fontWeight: "bold" }}
                      >
                        {taskStatus}
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 d-flex justify-content-between px-6">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab ">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        // className="nav-link active "
                        className={`${
                          tab === "information"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          setTab("information");
                          setTitle(taskId ? "Update Task" : "Add Task");
                        }}
                      >
                        Information
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "attachments"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          handleExternalSubmit("attachments");
                        }}
                        // onClick={() => setTab("attachments")}
                      >
                        Attachments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {attachmentCount}
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "notifications"
                            ? "nav-link active "
                            : "nav-link"
                        }`}
                        onClick={() => {
                          handleExternalSubmit("notifications");
                        }}
                      >
                        Notifications
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {notificationCount}
                      </div>
                    </li>
                    <li className=" rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${
                          tab === "comments" ? "nav-link active " : "nav-link"
                        }`}
                        onClick={() => {
                          setTab("comments");
                          setTitle(taskId ? "Update Task" : "Add Task");
                        }}
                      >
                        Comments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {commentCount}
                      </div>
                    </li>
                  </ul>
                  {/* <div className="status fs-3">
                    <h3>{taskStatus}</h3>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              {/* <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div> */}
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        // <form onSubmit={handleSubmit(onSubmit)}>
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card mb-5">
                            {/* card body */}
                            <div
                              className="card-body"
                              style={{ padding: "10px" }}
                            >
                              {/* form */}
                              <div className="row">
                                {/* form group */}
                                {!taskId && (
                                  <div className="mb-4 col-md-12 col-12 d-flex align-items-end">
                                    <label
                                      className=" pe-3"
                                      htmlFor="flexSwitchStock"
                                    >
                                      <strong>
                                        Add Task from Task Template
                                      </strong>
                                    </label>
                                    <div className="form-check form-switch d-flex justify-content-center align-items-center ">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchStock"
                                        checked={getTaskFromTemp}
                                        onClick={(e) => {
                                          if (e.target.checked) {
                                            setGetTaskFromTemp(true);
                                          } else {
                                            setSelectedTaskTempId("");
                                            setSelectedTaskTempOption({});
                                            setGetTaskFromTemp(false);
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                                {/* form group */}
                                {!taskId && (
                                  <div className="mb-4 col-md-12 col-12">
                                    <label className="form-label">
                                      Task Template
                                    </label>
                                    {/* <select
                                      className="form-select"
                                      disabled={!getTaskFromTemp}
                                      value={selectedTaskTempId}
                                      onChange={(e) => {
                                        if (e.target.value !== "") {
                                          fetchTaskTempDetail(e.target.value);
                                        }
                                      }}
                                    >
                                      <option value="">
                                        Select task template
                                      </option>
                                      {taskTempList?.map((item) => (
                                        <option value={item.ID}>
                                          {item?.Name}{" "}
                                          {item?.ProjTmplID
                                            ? `(Project Name:- ${item.parent_project_template_name})`
                                            : "(Standalone)"}
                                        </option>
                                      ))}
                                    </select> */}
                                    <Select
                                      // className="form-select"
                                      styles={customStyles}
                                      isDisabled={!getTaskFromTemp}
                                      value={selectedTaskTempOption}
                                      placeholder="Select Template."
                                      onChange={(option) => {
                                        console.log(option);
                                        if (option.value !== "") {
                                          fetchTaskTempDetail(option);
                                        }
                                      }}
                                      options={[
                                        {
                                          label: "Select a user",
                                          value: "",
                                          isDisabled: true,
                                        },
                                        ,
                                        ...convertToOptions(taskTempList),
                                      ]}
                                    />
                                  </div>
                                )}
                                {/* form group */}
                                {watchedFields.parentProjectName && (
                                  <div className="mb-4 col-md-4 col-12">
                                    <label className="form-label">
                                      Ord No{" "}
                                      {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <input
                                      type="number"
                                      min="0"
                                      className="form-control"
                                      placeholder="Enter ord no"
                                      disabled={
                                        taskStatus === "Done" ||
                                        taskStatus === "Cancelled"
                                          ? true
                                          : !(
                                              (userInfo?.user_code ===
                                                watchedFields.AllocBy ||
                                                isAdmin(userInfo)) &&
                                              taskStatus === "Pending"
                                            )
                                      }
                                      // disabled={
                                      //   !(
                                      //     (userInfo?.user_code ===
                                      //       watchedFields.AllocBy ||
                                      //       isAdmin(userInfo)) &&
                                      //     taskStatus === "Pending"
                                      //   )
                                      // }
                                      {...register("OrdNo", {
                                        // required: "Ord No is required",
                                      })}
                                    />
                                    {errors.OrdNo && (
                                      <div className="error">
                                        {errors.OrdNo.message}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {/* form group */}
                                {watchedFields.parentProjectName && (
                                  <div className="mb-4 col-md-4 col-12">
                                    <label className="form-label">
                                      Project Name{" "}
                                      {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter project name"
                                      disabled
                                      {...register("parentProjectName", {
                                        // required: "Ord No is required",
                                      })}
                                    />
                                    {errors.OrdNo && (
                                      <div className="error">
                                        {errors.OrdNo.message}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {/* form group */}
                                {watchedFields.parentProjectName && (
                                  <div className="mb-4 col-md-4 col-12">
                                    <label className="form-label">
                                      Project Lead{" "}
                                      {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter project lead"
                                      disabled
                                      {...register("parentProjectLead", {
                                        // required: "Ord No is required",
                                      })}
                                    />
                                    {errors.parentProjectLead && (
                                      <div className="error">
                                        {errors.parentProjectLead.message}
                                      </div>
                                    )}
                                  </div>
                                )}
                                {/* form group */}
                                {watchedFields.parentProjectName && (
                                  <div className="mb-4 col-md-12 col-12">
                                    <label className="form-label">
                                      Project Description{" "}
                                      {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <textarea
                                      type="text"
                                      rows={5}
                                      className="form-control"
                                      placeholder="Enter Description"
                                      disabled
                                      {...register("parentProjectDescription", {
                                        // required: "description is required",
                                      })}
                                    ></textarea>
                                    {errors.parentProjectDescription && (
                                      <div className="error">
                                        {
                                          errors.parentProjectDescription
                                            .message
                                        }
                                      </div>
                                    )}
                                  </div>
                                )}

                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Name
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="d-flex ">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter name"
                                      disabled={
                                        !(
                                          (userInfo?.user_code ===
                                            watchedFields.AllocBy ||
                                            isAdmin(userInfo)) &&
                                          taskStatus === "Pending"
                                        )
                                      }
                                      {...register("Name", {
                                        required: "Name is required",
                                        validate: validateNoBlankSpaces,
                                      })}
                                    />
                                    <div className="ps-1 m-auto">
                                      {" "}
                                      <strong>{taskId ? taskId : "ID"}</strong>
                                    </div>
                                  </div>
                                  {errors.Name && (
                                    <div className="error">
                                      {errors.Name.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Description{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    type="text"
                                    rows={5}
                                    className="form-control"
                                    placeholder="Enter Description"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        taskStatus === "Pending"
                                      )
                                    }
                                    {...register("Dscr", {
                                      required: "description is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  ></textarea>
                                  {errors.Dscr && (
                                    <div className="error">
                                      {errors.Dscr.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Lead
                                    <span className="text-danger">*</span>
                                  </label>
                                  {/* <select
                                    value={watchedFields.TaskLead}
                                    className="form-select"
                                    disabled={
                                      !((
                                        (userInfo.user_type === "Staff" ? ((projectId && userInfo?.user_code === watchedFields?.parentProjectLead) ? true : false) : (
                                          userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo))
                                        ) &&
                                        taskStatus === "Pending"
                                      )
                                        // && !(userInfo.user_type === "Staff" && projectId)
                                      )
                                    }
                                    {...register("TaskLead", {
                                      required: "Lead is required",
                                    })}
                                  >
                                    <option value="">Set Lead</option>
                                    {(formDefaultData?.users_list
                                      ? !formDefaultData?.users_list.includes(
                                        watchedFields.TaskLead
                                      )
                                      : false) && (
                                        <option value={watchedFields.TaskLead}>
                                          {" "}
                                          {watchedFields.TaskLead}
                                        </option>
                                      )}
                                    {formDefaultData?.users_list?.map(
                                      (item) => (
                                        <option value={item}>{item}</option>
                                      )
                                    )}
                                  </select> */}
                                  <Select
                                    value={{
                                      value: watchedFields.TaskLead,
                                      label: watchedFields.TaskLead,
                                    }}
                                    styles={customStyles}
                                    isDisabled={
                                      !(
                                        (
                                          (userInfo.user_type === "Staff"
                                            ? projectId &&
                                              userInfo?.user_code ===
                                                watchedFields?.parentProjectLead
                                              ? true
                                              : false
                                            : userInfo?.user_code ===
                                                watchedFields.AllocBy ||
                                              isAdmin(userInfo)) &&
                                          taskStatus === "Pending"
                                        )
                                        // && !(userInfo.user_type === "Staff" && projectId)
                                      )
                                    }
                                    placeholder="Select Staff."
                                    onChange={(option) => {
                                      console.log(option);
                                      if (option.value !== "") {
                                        setValue("TaskLead", option.value);
                                      }
                                    }}
                                    options={[
                                      {
                                        label: "Select a user",
                                        value: "",
                                        isDisabled: true,
                                      },
                                      ...convertToUserOptions(
                                        formDefaultData?.users_list
                                      ),
                                    ]}
                                  />
                                  {/* {errors.TaskLead && (
                                    <div className="error">
                                      {errors.TaskLead.message}
                                    </div>
                                  )} */}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Allocate By
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    value={watchedFields.AllocBy}
                                    disabled
                                    // disabled={
                                    //   !(
                                    //     isAdmin(userInfo) &&
                                    //     taskStatus === "Pending"
                                    //   )
                                    // }
                                    className="form-select"
                                    {...register("AllocBy", {
                                      required: "AllocBy is required",
                                    })}
                                  >
                                    <option value="">Set Allocate By</option>
                                    {(formDefaultData?.users_list
                                      ? !formDefaultData?.users_list.includes(
                                          watchedFields.AllocBy
                                        )
                                      : false) && (
                                      <option value={watchedFields.AllocBy}>
                                        {" "}
                                        {watchedFields.AllocBy}
                                      </option>
                                    )}
                                    {formDefaultData?.users_list?.map(
                                      (item) => (
                                        <option value={item}>{item}</option>
                                      )
                                    )}
                                  </select>
                                  {/* <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Allocate By."
                                    disabled
                                    {...register("AllocBy", {
                                      // required: "Approx Days is required",
                                    })}
                                  /> */}

                                  {errors.AllocBy && (
                                    <div className="error">
                                      {errors.AllocBy.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Priority
                                    <span className="text-danger">*</span>
                                  </label>

                                  <select
                                    className="form-select"
                                    value={watchedFields.Priority}
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        (taskStatus === "Pending" ||
                                          taskStatus === "In Process")
                                      )
                                    }
                                    {...register("Priority", {
                                      required: "Priority is required",
                                    })}
                                  >
                                    <option value="">Set Priority</option>

                                    {transformedArray(
                                      formDefaultData?.priority_list
                                    )?.map((item) => (
                                      <option value={item.id}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                  {errors.Priority && (
                                    <div className="error">
                                      {errors.Priority.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Approx Days{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Days"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        !(
                                          taskStatus === "Done" ||
                                          taskStatus === "Cancelled" ||
                                          taskStatus === "Pending Review"
                                        )
                                      )
                                    }
                                    {...register("AprxDays", {
                                      required: "Approx Days is required",
                                      onChange: (e) => {
                                        onDateOrDurationChange(
                                          e.target.value,
                                          "day"
                                        );
                                      },
                                    })}
                                  />
                                  {errors.AprxDays && (
                                    <div className="error">
                                      {errors.AprxDays.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Approx Hours{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Hours"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        !(
                                          taskStatus === "Done" ||
                                          taskStatus === "Cancelled" ||
                                          taskStatus === "Pending Review"
                                        )
                                      )
                                    }
                                    {...register("AprxHours", {
                                      max: {
                                        value: 23,
                                        message:
                                          "approx hours must be less than 24",
                                      },
                                      required: "Approx Hours is required",
                                      onChange: (e) => {
                                        onDateOrDurationChange(
                                          e.target.value,
                                          "hours"
                                        );
                                      },
                                    })}
                                  />
                                  {errors.AprxHours && (
                                    <div className="error">
                                      {errors.AprxHours.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6 ">
                                  <label className="form-label">
                                    Approx Minutes{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Minutes"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        !(
                                          taskStatus === "Done" ||
                                          taskStatus === "Cancelled" ||
                                          taskStatus === "Pending Review"
                                        )
                                      )
                                    }
                                    {...register("AprxMinutes", {
                                      max: {
                                        value: 59,
                                        message:
                                          "approx minutes must be less than 60",
                                      },
                                      required: "Approx Minutes is required",
                                      onChange: (e) => {
                                        onDateOrDurationChange(
                                          e.target.value,
                                          "minutes"
                                        );
                                      },
                                    })}
                                  />
                                  {errors.AprxMinutes && (
                                    <div className="error">
                                      {errors.AprxMinutes.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-6 col-12">
                                  <label className="form-label">
                                    Planned Start{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      disabled={
                                        !(
                                          (userInfo?.user_code ===
                                            watchedFields.AllocBy ||
                                            isAdmin(userInfo)) &&
                                          taskStatus === "Pending"
                                        )
                                      }
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      {...register("StartDtTm", {
                                        required: "Start Date is required",
                                        onChange: (e) => {
                                          onDateOrDurationChange(
                                            e.target.value,
                                            "startDate"
                                          );
                                        },
                                      })}
                                    />
                                  </div>
                                  {errors.StartDtTm && (
                                    <div className="error">
                                      {errors.StartDtTm.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-12">
                                  <label className="form-label">
                                    Planned End{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      disabled={
                                        !(
                                          (userInfo?.user_code ===
                                            watchedFields.AllocBy ||
                                            isAdmin(userInfo)) &&
                                          (taskStatus === "Pending" ||
                                            taskStatus === "In Process")
                                        )
                                      }
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      {...register("EndDtTm", {
                                        required: "End Date is required",
                                      })}
                                    />
                                  </div>
                                  {errors.EndDtTm && (
                                    <div className="error">
                                      {errors.EndDtTm.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className=" col-md-6 col-12 d-flex justify-content-lg-start justify-content-md-start justify-content-start">
                                  <label
                                    className="form-label d-flex "
                                    style={{ marginBottom: "0px" }}
                                  >
                                    {/* Actual Start{" "} */}
                                    {/* <span className="text-danger">*</span> */}
                                    <div
                                      className="fw-normal "
                                      style={{ width: "83px" }}
                                    >
                                      Actual Start{" "}
                                    </div>
                                    :{" "}
                                    {formatDateTimetoAmPm(
                                      watchedFields?.ActualStDtTm
                                    )}
                                  </label>
                                  {/* <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      disabled
                                      {...register("ActualStDtTm", {
                                      })}
                                    />
                                  </div> */}
                                  {errors.ActualStDtTm && (
                                    <div className="error">
                                      {errors.ActualStDtTm.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-2 col-md-6 col-12 d-flex justify-content-lg-end justify-content-md-end justify-content-start">
                                  <label className="form-label d-flex">
                                    <div
                                      className="fw-normal"
                                      style={{ width: "83px" }}
                                    >
                                      Actual End
                                    </div>
                                    :{" "}
                                    {formatDateTimetoAmPm(
                                      watchedFields?.ActualEndDtTm
                                    )}
                                  </label>
                                  {/* <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      disabled
                                      {...register("ActualEndDtTm", {
                                      })}
                                    />
                                  </div> */}
                                  {errors.ActualEndDtTm && (
                                    <div className="error">
                                      {errors.ActualEndDtTm.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                              </div>
                              <div className="row  justify-content-between ">
                                {taskStatus === "Pending" &&
                                  userInfo?.user_code ===
                                    watchedFields.TaskLead &&
                                  taskId && (
                                    <div className=" d-flex col-lg-2 col-md-4 col-122 mb-4 ">
                                      <button
                                        className={`btn btn-success  w-100  ${
                                          taskStatus === "Pending" &&
                                          userInfo?.user_code ===
                                            watchedFields.TaskLead &&
                                          taskId
                                            ? ""
                                            : "disabled"
                                        }`}
                                        style={{ width: "min(210px,100%)" }}
                                        onClick={() => setIsStartAction(true)}
                                      >
                                        Start
                                      </button>
                                    </div>
                                  )}
                                {(isAdmin(userInfo) ||
                                  (watchedFields.parentProjectLead ===
                                    userInfo.user_code) |
                                    (watchedFields.AllocBy ===
                                      userInfo.user_code)) &&
                                (taskStatus === "Pending" ||
                                  taskStatus === "In Process") &&
                                taskId ? (
                                  <div
                                    className="  rounded-circl notification-count col-lg-2 col-md-4 col-12 mb-4"
                                    // style={{ width: "300px" }}
                                  >
                                    <button
                                      className={`btn  btn-outline-danger w-100  `}
                                      onClick={() =>
                                        setIsCancelTaskAction(true)
                                      }
                                    >
                                      Cancel Task
                                    </button>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {taskStatus === "In Process" &&
                                  userInfo?.user_code ===
                                    watchedFields.TaskLead &&
                                  taskId && (
                                    <div className=" d-flex  col-lg-2   col-md-4 col-12 mb-4 ">
                                      <button
                                        className={`btn btn-success w-100  ${
                                          taskStatus === "In Process" &&
                                          userInfo?.user_code ===
                                            watchedFields.TaskLead &&
                                          taskId
                                            ? ""
                                            : "disabled"
                                        }`}
                                        onClick={() => setIsDoneAction(true)}
                                      >
                                        Done
                                      </button>
                                    </div>
                                  )}
                              </div>
                            </div>
                            <div className=" col-md-12 col-12">
                              <label
                                className="form-label"
                                style={{ margin: "0px" }}
                              >
                                <h3
                                  style={{ margin: "0px", paddingLeft: "20px" }}
                                >
                                  Sub Tasks{" "}
                                  <span className="text-danger">*</span>
                                </h3>
                              </label>
                              <SubTaskList
                                setIsSaveAndAddSubtask={setIsSaveAndAddSubtask}
                                setIsSaveAndEditeSubtask={
                                  setIsSaveAndEditeSubtask
                                }
                                setEditSubTaskId={setEditSubTaskId}
                                watchedFields={watchedFields}
                                taskStatus={taskStatus}
                              />
                            </div>
                          </div>
                          <div className="mt-4 mb-4  flex-wrap justify-content-between gap-4 bottom-btns-mobile">
                            {(isAdmin(userInfo) ||
                              watchedFields.parentProjectLead ===
                                userInfo.user_code ||
                              watchedFields.AllocBy === userInfo.user_code) &&
                              taskStatus === "Pending Review" &&
                              taskId && (
                                <div className="left d-flex  gap-3 align-items-center justify-content-between w-100">
                                  <div
                                    className="  rounded-circl notification-count"
                                    style={{ width: "80.63px" }}
                                  >
                                    {(isAdmin(userInfo) ||
                                      watchedFields.parentProjectLead ===
                                        userInfo.user_code ||
                                      watchedFields.AllocBy ===
                                        userInfo.user_code) &&
                                    taskStatus === "Pending Review" &&
                                    taskId ? (
                                      <div
                                        // className="btn btn-outline-danger me-2"
                                        className={`btn  btn-outline-danger w-100  `}
                                        // onClick={() => rejectTask(taskId)}

                                        onClick={() => {
                                          handleConfirmationResonShow();
                                          setFunHandler({
                                            fun: rejectTask,
                                            id: taskId,
                                            isGetReason: true,
                                            lable: "Rejection comment",
                                            title: "reject task.",
                                          });
                                        }}
                                      >
                                        Reject
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {/* <div className="notification-count">24</div> */}
                                  </div>
                                  <div
                                    className="  rounded-circl notification-count "
                                    style={{ width: "80.63px" }}
                                  >
                                    {(isAdmin(userInfo) ||
                                      watchedFields.parentProjectLead ===
                                        userInfo.user_code ||
                                      watchedFields.AllocBy ===
                                        userInfo.user_code) &&
                                    taskStatus === "Pending Review" &&
                                    taskId ? (
                                      <div
                                        className={`btn btn-success w-100 `}
                                        // onClick={() => acceptTask(taskId)}
                                        // disabled={!( isAdmin(userInfo) &&  taskStatus === "Pending Review" && taskId)}

                                        onClick={() => {
                                          handleConfirmationResonShow();
                                          setFunHandler({
                                            fun: acceptTask,
                                            id: taskId,
                                            isGetReason: true,
                                            lable: "Closing comment",
                                            title: "accept task.",
                                          });
                                        }}
                                      >
                                        Accept
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {/* <div className="notification-count">24</div> */}
                                  </div>
                                </div>
                              )}
                            {/* {taskStatus === "Pending Review" && taskId && ( */}

                            {/* // )} */}
                            <div className="d-flex right align-items-center gap-3 justify-content-between w-100">
                              <div
                                className="btn btn-outline-danger "
                                style={{ height: "fit-content" }}
                                onClick={() => {
                                  if (taskId) {
                                    navigateToTaskWithId(taskId);
                                    // navigate(`/task?taskId=${taskId}`);
                                  } else {
                                    navigateToTask();
                                    // navigate("/task");
                                  }
                                }}
                              >
                                Cancel
                              </div>
                              <button
                                className="  btn btn-primary  "
                                disabled={
                                  taskId
                                    ? !(
                                        (taskStatus === "Pending" ||
                                          taskStatus === "In Process") &&
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          userInfo?.user_code ===
                                            watchedFields.TaskLead ||
                                          userInfo?.user_code ===
                                            watchedFields.parentProjectLead ||
                                          isAdmin(userInfo))
                                      )
                                    : false
                                }
                                // disabled={
                                //   !(
                                //     (taskStatus === "Pending" ||
                                //       taskStatus === "In Process") &&
                                //     userInfo?.user_code ===
                                //       watchedFields.AllocBy &&
                                //     taskId
                                //   )
                                // }
                              >
                                Save
                              </button>
                            </div>
                          </div>
                          <div className="mt-4 mb-4  justify-content-between gap-4   bottom-btns-web">
                            <div className="left d-flex flex-wrap gap-3 align-items-center">
                              <div
                                className="btn btn-outline-danger "
                                style={{ height: "fit-content" }}
                                onClick={() => {
                                  if (taskId) {
                                    navigateToTaskWithId(taskId);
                                    // navigate(`/task?taskId=${taskId}`);
                                  } else {
                                    navigateToTask();
                                    // navigate("/task");
                                  }
                                }}
                              >
                                Cancel
                              </div>
                            </div>
                            {/* {taskStatus === "Pending Review" && taskId && ( */}
                            <div className="center d-flex flex-wrap gap-4 justify-content-center">
                              <div
                                className="  rounded-circl notification-count"
                                style={{ width: "80.63px" }}
                              >
                                {(isAdmin(userInfo) ||
                                  watchedFields.parentProjectLead ===
                                    userInfo.user_code ||
                                  watchedFields.AllocBy ===
                                    userInfo.user_code) &&
                                taskStatus === "Pending Review" &&
                                taskId ? (
                                  <div
                                    // className="btn btn-outline-danger me-2"
                                    className={`btn  btn-outline-danger w-100   `}
                                    onClick={() => {
                                      handleConfirmationResonShow();
                                      setFunHandler({
                                        fun: rejectTask,
                                        id: taskId,
                                        isGetReason: true,
                                        lable: "Rejection comment",
                                        title: "reject task.",
                                      });
                                    }}
                                  >
                                    Reject
                                  </div>
                                ) : (
                                  ""
                                )}
                                {/* <div className="notification-count">24</div> */}
                              </div>
                              <div
                                className="  rounded-circl notification-count "
                                style={{ width: "80.63px" }}
                              >
                                {(isAdmin(userInfo) ||
                                  watchedFields.parentProjectLead ===
                                    userInfo.user_code ||
                                  watchedFields.AllocBy ===
                                    userInfo.user_code) &&
                                taskStatus === "Pending Review" &&
                                taskId ? (
                                  <div
                                    className={`btn btn-success w-100  `}
                                    onClick={() => {
                                      handleConfirmationResonShow();
                                      setFunHandler({
                                        fun: acceptTask,
                                        id: taskId,
                                        isGetReason: true,
                                        lable: "Closing comment",
                                        title: "accept task.",
                                      });
                                    }}
                                  >
                                    Accept
                                  </div>
                                ) : (
                                  ""
                                )}
                                {/* <div className="notification-count">24</div> */}
                              </div>
                            </div>
                            {/* // )} */}
                            <div className="d-flex right align-items-center">
                              <button
                                className="  btn btn-primary  "
                                disabled={
                                  taskId
                                    ? !(
                                        (taskStatus === "Pending" ||
                                          taskStatus === "In Process") &&
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          userInfo?.user_code ===
                                            watchedFields.TaskLead ||
                                          userInfo?.user_code ===
                                            watchedFields.parentProjectLead ||
                                          isAdmin(userInfo))
                                      )
                                    : false
                                }
                                // disabled={
                                //   !(
                                //     (taskStatus === "Pending" ||
                                //       taskStatus === "In Process") &&
                                //     userInfo?.user_code ===
                                //       watchedFields.AllocBy &&
                                //     taskId
                                //   )
                                // }
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      );
                    case "attachments":
                      return (
                        <Attachment
                          setTab={setTab}
                          setAttachmentCount={setAttachmentCount}
                          setTitle={setTitle}
                          attachmentType={"task"}
                          TranType={7}
                          AttchType={1}
                        />
                      );
                    case "notifications":
                      return (
                        <Notification
                          isStaffNotification={false}
                          setNotificationCount={setNotificationCount}
                          TranType={7}
                          TranMID={tranMID}
                          setTitle={setTitle}
                          TaskAllocBy={watchedFields.AllocBy}
                          TaskLead={watchedFields.TaskLead}
                          ProjectLead={watchedFields.parentProjectLead}
                          detailRefetch={taskDetailRefetch}
                          setTab={setTab}
                        ></Notification>
                      );
                    case "comments":
                      return (
                        <div className="w-100">
                          <div className="card mb-5">
                            {/* card body */}
                            <div className="card-body">
                              {/* form group */}

                              <div className="mb-4 col-md-12 col-12">
                                <label className="form-label">
                                  Closing Comment{" "}
                                </label>
                                <textarea
                                  type="text"
                                  rows={5}
                                  value={closingComment}
                                  className="form-control"
                                  // placeholder="Comment..."
                                  disabled
                                ></textarea>
                                {errors.Dscr && (
                                  <div className="error">
                                    {errors.Dscr.message}
                                  </div>
                                )}
                              </div>
                              <div className="mb-4 col-md-12 col-12">
                                <label className="form-label">
                                  Delay Reason{" "}
                                </label>
                                <textarea
                                  type="text"
                                  rows={5}
                                  value={delayReason}
                                  className="form-control"
                                  // placeholder="Enter Description"
                                  disabled
                                ></textarea>
                                {errors.Dscr && (
                                  <div className="error">
                                    {errors.Dscr.message}
                                  </div>
                                )}
                              </div>
                              <div className="mb-4 col-md-12 col-12">
                                <label className="form-label">
                                  Rejection Reason{" "}
                                </label>
                                <textarea
                                  type="text"
                                  rows={5}
                                  value={rejectionReason}
                                  className="form-control"
                                  // placeholder="Enter Description"
                                  disabled
                                ></textarea>
                                {errors.Dscr && (
                                  <div className="error">
                                    {errors.Dscr.message}
                                  </div>
                                )}
                              </div>
                              <div className="mb-4 col-md-12 col-12">
                                <label className="form-label">
                                  Cancel Reason{" "}
                                </label>
                                <textarea
                                  type="text"
                                  rows={5}
                                  value={cancelReason}
                                  className="form-control"
                                  // placeholder="Enter Description"
                                  disabled
                                ></textarea>
                                {errors.Dscr && (
                                  <div className="error">
                                    {errors.Dscr.message}
                                  </div>
                                )}
                              </div>

                              {/* </div> */}
                              <div className=" d-flex flex-wrap gap-3 align-items-center justify-content-end  ">
                                <div
                                  className="btn btn-outline-danger  col-md-2 col-12 "
                                  style={{ height: "fit-content" }}
                                  onClick={() => {
                                    setTab("information");

                                    // if (taskId) {
                                    //   navigateToTaskWithId(taskId);
                                    //   // navigate(`/task?taskId=${taskId}`);
                                    // } else {
                                    //   navigateToTask();
                                    //   // navigate("/task");
                                    // }
                                  }}
                                >
                                  Back
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );

                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewPasswordModal
        show={show}
        onHide={handleClose}
        newPassword={newPassword}
        title="Initial Password"
      />
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
      <ConfirmationReasonModal
        show={confirmationResonShow}
        onHide={handleConfirmationResonClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default AddUpdateTask;
